import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import { GET_ORG_USERS_WITH_ROLES } from "../../../queries";
import Sidebar2 from "../../Sidebar2";
import { TitleSource } from "../teleporters/Title";
import RegisterForm from "./Users/RegisterForm";
import AddForm from "./Users/AddForm";
import UserProfile from "./Users/UserProfile";
import UsersList from "./Users/UsersList";
//  RESET PASS:
//      https://auth.syncarto.com/forgotPassword?client_id=4l5aa7mfeladl4ibaec9f8t2h2&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://app.syncarto.com/login
//          .env VARS:
//              redirect_uri=https://app.syncarto.com/login
//              client_id=4l5aa7mfeladl4ibaec9f8t2h2

const OrgUsers = (props:any) => {
    console.log('OrgUsers props',props);
    let orgId = props.currentUser.orgId;

    const [showSidebar, setShowSidebar] = useState<boolean>(false);
    const [selectedUser, setSelectedUser] = useState<any>(null);
    const [users, setUsers] = useState<any>([]);
    const [showCreateContact, setShowCreateContact] = useState<boolean>(false);
    const [showAddContact, setShowAddContact] = useState<boolean>(false);

    const [emailSignup, setEmailSignup] = useState<any>(null);

    useEffect(() => {
        loadUsers();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const loadUsers = () => {
        console.log('072721 calling OrgUsers > loadUsers()')
        console.log('072721 props', props)
        var data = {
            org_id: orgId
        };

        props.client.query({
            query: GET_ORG_USERS_WITH_ROLES,
            variables: data,
            /*optimisticResponse: {
                "id":"dfeeaa8b-b7aa-4004-bca2-a4232a5dfd69",
                "email":"codiesee+7@gmail.com",
                "name":"Codie 7",
                "org_user":[{
                    "id":147,
                    "role":{"name":"None",
                        "id":0,
                        "__typename":"syncarto_app_role"
                    },
                    "__typename":"syncarto_app_org_user"
                }],
                "__typename":"syncarto_app_user"
            },*/
            fetchPolicy: "no-cache"
        }).then((result: any) => {
            console.log('072721 GET_ORG_USERS_WITH_ROLES', result);
            setUsers(transform(result.data));
        });
    }

    const transform = (data: any) => {
        let orgUsers = data.syncarto_app_org_by_pk.org_users;

        return orgUsers.map((item: any) => {
            return {
                id: item.user.id,
                name: item.user.name,
                email: item.user.email,
                roles: item.user.org_user.map((r: any) => {
                    return r.role.name;
                }).join(', ')
            }
        });
    }

    const onSelectedUserId = (userId:any) => {
        setShowCreateContact(false);
        setShowAddContact(false);
        setSelectedUser(userId);
        setShowSidebar(true);
    }

    const onSidebarHide = (userId:any) => {
        setShowSidebar(false);
    }

    const shouldRefreshUsers = () => {
        console.log('072721 calling OrgUsers > loadUsers() from OrgUsers > shouldRefreshUsers()')
        loadUsers();
    }

    const addNewDCUser = (emailSignup:string) => {
        console.log('Switching from "add user" to "create user" ... ')
        setShowSidebar(false);
        setSelectedUser(null);
        setEmailSignup(emailSignup);
        setShowCreateContact(true);
        setShowAddContact(false);
        setShowSidebar(true);
    }

    const onShowCreateContact = (e:any) => {
        e.preventDefault();
        setSelectedUser(null);
        setShowCreateContact(true);
        setShowAddContact(false);
        setShowSidebar(true);
    }

    const onShowAddContact = (e:any) => {
        e.preventDefault();
        setSelectedUser(null);
        setShowCreateContact(false);
        setShowAddContact(true);
        setShowSidebar(true);
    }

    return (
        <div className="m-2-syncarto">
            <TitleSource><h4 className="m-0 mt-1">Organization - Users</h4></TitleSource>  
            <div className="p-4">
                <UsersList orgId={orgId} users={users} onSelectedUserId={onSelectedUserId} {...props}></UsersList> 
                <Button 
                    variant="primary"
                    onClick={onShowCreateContact}>
                        Create User
                </Button>    
                <Button style={{marginLeft: "5px"}}
                    variant="primary"
                    onClick={onShowAddContact}>
                        Add User
                </Button>    
            </div>  
            <Sidebar2 width={500} show={showSidebar} onHide={onSidebarHide} >
                {selectedUser && <UserProfile orgId={orgId} userId={selectedUser} shouldRefreshUsers={shouldRefreshUsers} {...props}></UserProfile>}
                {showCreateContact && <RegisterForm orgId={orgId} shouldRefreshUsers={shouldRefreshUsers} {...props} emailSignup={emailSignup}></RegisterForm>}
                {showAddContact && <AddForm orgId={orgId} shouldRefreshUsers={shouldRefreshUsers} onSelectedUserId={onSelectedUserId} addNewDCUser={addNewDCUser} {...props}></AddForm>}
            </Sidebar2> 
        </div>
    );
}

export default OrgUsers;